"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startWith = void 0;

var _Observable = require("./Observable");

var startWith = function startWith(init, source) {
  return (0, _Observable.mkObservable)(function (observer) {
    observer.next(init);
    return source.subscribe(observer);
  });
};

exports.startWith = startWith;